import React from "react";
import FuelPieChart from "../../components/graphs/FuelPieChart";
import PriceMap from "../../components/graphs/PriceMap";
import { useAppSelector } from "../../redux";
import "./ISO.css";

// https://stackoverflow.com/questions/2901102/how-to-format-a-number-with-commas-as-thousands-separators
const numberWithCommas = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const formatDate = (dateStr: string | undefined): string => {
  if (!dateStr) return "...";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "...";
  return date.toLocaleString("en-us", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const ISO: React.FC = () => {
  const report = useAppSelector((state) => state.report);
  const snapshotData = report.data[0];

  return (
    <div className="iso">
      <div className="title-nonabs-container">
        <div className="title-container">
          <div className="title">Regional Energy Data</div>
          <div className="isoSubheader">
            New England states differ in what they use for energy, how much
            energy costs, and how much demand for energy there is. This
            dashboard compares some of these metrics.
          </div>
        </div>
      </div>
      <div className="isoMain">
        <div className="isoGraphs">
          <div className="isoPriceMapBox">
            <div className="isoBoxTitle">Price Map</div>
            <div className="isoMapContent">
              <div className="isoPriceMapText">
                Prices are in dollars per megawatt hour (MWh). Other marked
                locations on the map are interconnection facilities
              </div>
              <div className="isoPriceMap">
                <PriceMap scale={0.6}></PriceMap>
              </div>
            </div>
          </div>
          <div className="isoResMixBox">
            <div className="isoBoxTitle">Resource Mix</div>
            <div className="isoResMix">
              <FuelPieChart scale={0.6}></FuelPieChart>
            </div>
          </div>
        </div>
        <div className="isoSnapshot">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className="isoBoxTitle" style={{ margin: 0, lineHeight: 1 }}>
              Today&apos;s Snapshot
            </div>

            <div style={{ marginTop: 5, fontSize: 16 }}>
              {formatDate(report.lastUpdated)}
            </div>
          </div>
          <div className="isoSnapshotInfo">
            <div className="isoSnapshotData">
              <div className="isoSnapshotNum">
                {snapshotData
                  ? numberWithCommas(snapshotData.availableCapacity)
                  : "..."}
              </div>
              <div className="isoSnapshotSubtitle">Available Capacity (MW)</div>
            </div>
            <div className="isoSnapshotData">
              <div className="isoSnapshotNum">
                {snapshotData
                  ? numberWithCommas(snapshotData.forecastedPeakDemand)
                  : "..."}
              </div>
              <div className="isoSnapshotSubtitle">
                Forecasted Peak Demand (MW)
              </div>
            </div>
            <div className="isoSnapshotData">
              <div className="isoSnapshotNum">
                {snapshotData
                  ? numberWithCommas(snapshotData.surplusCapacity)
                  : "..."}
              </div>
              <div className="isoSnapshotSubtitle">Surplus Capacity (MW)</div>
            </div>
            <div className="isoSnapshotData">
              <div className="isoSnapshotNum">
                {snapshotData
                  ? numberWithCommas(snapshotData.yesterdaysPeakDemand)
                  : "..."}
              </div>
              <div className="isoSnapshotSubtitle">
                Yesterday&apos;s Peak Demand (MW)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
